import { Utils } from '@genial/utils';
import * as zod from 'zod';

export type FixedIncomeFormData = { createAppliedAmount: string };

export const getValidationCreateSchema = (minValue: number, maxValue: number) =>
  zod.object({
    createAppliedAmount: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= Number(minValue?.toFixed(2) || 0), {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= Number(maxValue?.toFixed(2) || 0), {
        message: `Valor máximo ${Utils.Mask.Money(maxValue)}`,
      }),
  });
